import { ProductAdminRequestDTO } from "Interface/Admin/Products/admin-product.interface";
import React from "react";
import { useAppSelector } from "State/Hooks";

interface SalesSectionProps {
    formData: ProductAdminRequestDTO;
    setFormData: React.Dispatch<React.SetStateAction<ProductAdminRequestDTO>>;
    mode: "add" | "edit" | "view";
    open: boolean;
    toggleSection: () => void;
}

export const SalesSection: React.FC<SalesSectionProps> = ({
    formData,
    setFormData,
    mode,
    open,
    toggleSection,
}) => {
    const config = useAppSelector((state: any) => state.configuration.config);
    const numberOfDecimal = config?.numberOfDecimal ? parseInt(config.numberOfDecimal, 10) : 2;

    const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
        const { name, value } = e.target;
        setFormData((prev) => ({ ...prev, [name]: value }));
    };

    return (
        <div className="font-body tracking-wider border rounded-md">
            <button
                type="button"
                onClick={toggleSection}
                className="w-full px-4 py-3 text-left flex justify-between items-center hover:bg-gray-50"
            >
                <h3 className="text-lg font-medium">Sales</h3>
                {open ? (
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-chevron-up h-5 w-5"><path d="m18 15-6-6-6 6" /></svg>
                ) : (
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-chevron-down h-5 w-5"><path d="m6 9 6 6 6-6" /></svg>
                )}
            </button>
            {open && (
                <div className="px-4 pb-4 grid grid-cols-1 md:grid-cols-2 gap-4">
                    <div>
                        <label className="block text-sm font-medium text-gray-500 mb-1">Sales UOM</label>
                        <select
                            name="salesUom"
                            value={formData.salesUom || "pcs"}
                            onChange={handleChange}
                            className="w-full px-3 py-2 border rounded-md text-sm"
                            disabled={mode === "view"}
                        >
                            <option value="pcs">PCS</option>
                        </select>
                    </div>
                    <div>
                        <label className="block text-sm font-medium text-gray-500 mb-1">MRP</label>
                        <input
                            type="number"
                            min="0"
                            step="any"
                            name="mrp"
                            onWheel={(e) => e.currentTarget.blur()}
                            value={mode === "view" ? Number(formData.mrp || 0).toFixed(numberOfDecimal) : formData.mrp}
                            onChange={handleChange}
                            className="w-full px-3 py-2 border rounded-md text-sm"
                            readOnly={mode === "view"}
                        />
                    </div>
                    <div>
                        <label className="block text-sm font-medium text-gray-500 mb-1">
                            Selling Price
                            {Number(formData.sellingPrice) > Number(formData.mrp) && (
                                <span className="text-red-500 text-xs ml-1">(Cannot be greater than MRP)</span>
                            )}
                        </label>
                        <input
                            type="number"
                            min="0"
                            step="any"
                            name="sellingPrice"
                            onWheel={(e) => e.currentTarget.blur()}
                            value={mode === "view" ? Number(formData.sellingPrice || 0).toFixed(numberOfDecimal) : formData.sellingPrice}
                            onChange={handleChange}
                            className={`w-full px-3 py-2 border rounded-md text-sm ${Number(formData.sellingPrice) > Number(formData.mrp) ? "border-red-500" : ""
                                }`}
                            readOnly={mode === "view"}
                        />
                    </div>
                    <div>
                        <label className="block text-sm font-medium text-gray-500 mb-1">Minimum Selling Price</label>
                        <input
                            type="number"
                            min="0"
                            step="any"
                            name="minimumSellingPrice"
                            onWheel={(e) => e.currentTarget.blur()}
                            value={mode === "view" ? Number(formData.minimumSellingPrice || 0).toFixed(numberOfDecimal) : formData.minimumSellingPrice}
                            onChange={handleChange}
                            className="w-full px-3 py-2 border rounded-md text-sm"
                            readOnly={mode === "view"}
                        />
                    </div>
                    <div>
                        <label className="block text-sm font-medium text-gray-500 mb-1">ISBN Price</label>
                        <input
                            type="number"
                            min="0"
                            step="any"
                            name="isbnPrice"
                            onWheel={(e) => e.currentTarget.blur()}
                            value={
                                mode === "view"
                                    ? formData.isbnPrice !== null && formData.isbnPrice !== undefined
                                        ? Number(formData.isbnPrice).toFixed(numberOfDecimal)
                                        : ""
                                    : formData.isbnPrice ?? ""
                            }
                            onChange={handleChange}
                            placeholder="0.00"
                            className="w-full px-3 py-2 border rounded-md text-sm"
                            readOnly={mode === "view"}
                        />
                    </div>
                </div>
            )}
        </div>
    );
};